<template>
    <div class="pages news-module" v-cloak>
        <headerView :show-bg="true"></headerView>
        <!-- <div class="topseat-wrap">
            <div class="topseat w1280">
                <span>
                    <span>{{ $t("article_seat1") }}</span>
                    <span>
                        <i class="el-icon-arrow-right"></i>
                        <span>{{ pageType == 2 ? '新闻动态' : '案例中心'}}</span>
                    </span>
                </span>
            </div>
        </div> -->
        <div class="component person-nav">
            <div class="van-sticky">
                <div class="news-module__inner">

                    <div class="news-module__hot" v-if="hotList && hotList.length > 0">
                        <h2 class="news-module__section-title">热门动态</h2>
                        <div class="news-module__hot-body">
                            <a class="news-module__hot-main"
                                :href="hotList[0] && (hotList[0].linkUrl || 'javascript:void(0);')" target="_blank‌">
                                <div class="news-module__hot-main-img">
                                    <img v-if="hotList[0] && hotList[0].imgUrl" :src="hotList[0].imgUrl" alt="" />
                                </div>
                                <div class="news-module__hot-main-body">
                                    <span class="news-module__hot-tag" v-if="hotList[0].tag">{{ hotList[0] &&
                                        hotList[0].tag }}</span>
                                    <p class="news-module__hot-main-title">{{ hotList[0] && hotList[0].title }}</p>
                                    <p class="news-module__hot-main-date">
                                        <i class="el-icon-date"></i>
                                        <span>{{ hotList[0] && hotList[0].date }}</span>
                                    </p>
                                    <p class="news-module__hot-main-desc">{{ hotList[0] && hotList[0].description }}</p>
                                    <p class="news-module__hot-main-more">查看详情 &gt;&gt;</p>
                                </div>
                            </a>
                            <div class="news-module__hot-side">
                                <a v-for="(item, idx) in hotList" :key="'h' + idx" class="news-module__hot-side-item"
                                    :href="item.linkUrl || 'javascript:void(0);'" target="_blank‌">
                                    <div class="news-module__hot-side-img">
                                        <img v-if="item.imgUrl" :src="item.imgUrl" alt="" />
                                    </div>
                                    <div class="news-module__hot-side-text">
                                        <p class="news-module__hot-side-title">{{ item.title }}</p>
                                        <p class="news-module__hot-side-date">
                                            <i class="el-icon-date"></i>
                                            <span>{{ item.date }}</span>
                                        </p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="news-module__news" v-loading="listLoading">
                        <div class="news-module__news-head">
                            <h2 class="news-module__section-title">{{ pageType == 2 ? '新闻动态' : '案例中心' }}</h2>
                            <div class="news-module__news-cats">
                                <span v-for="(cat, idx) in categories" :key="'c' + idx" class="news-module__news-cat"
                                    :class="{ active: currentCategory === cat.id }" @click="handCategory(cat.id)">{{
                                        cat.typeName }}</span>
                            </div>
                            <el-input :placeholder="$t('placeholder')" v-model="pageTitle" class="input-with-select"
                                @keyup.enter.native="handleFilter">
                                <el-button slot="append" icon="el-icon-search" @click="handleFilter"></el-button>
                            </el-input>
                        </div>

                        <div class="news-module__list news-list1" v-if="stateSche == 0 || stateSche == 1">
                            <a v-for="(item, idx) in list" :key="idx" class="news-module__card"
                                :href="item.linkUrl || 'javascript:void(0);'" target="_blank‌">
                                <div class="news-module__card-item">
                                    <div class="news-module__card-img">
                                        <img v-if="item.imgUrl" :src="item.imgUrl" alt="" />
                                    </div>
                                    <div class="news-module__card-body">
                                        <span class="news-module__card-tag" v-if="item.tag">{{ item.tag }}</span>
                                        <p class="news-module__card-title">{{ item.title }}</p>
                                        <p class="news-module__card-desc">{{ item.description }}</p>
                                        <div class="news-module__card-foot">
                                            <span class="news-module__card-date">{{ item.date }}</span>
                                            <img src="@/assets/images/arrow.png" class="arrow" />

                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <pagination style="text-align: center;" v-show="total > 0" :total="total"
                            :page.sync="listQuery.Page" :limit.sync="listQuery.Limit" @pagination="handlePagination" />
                    </div>

                    <div class="nodata" v-if="stateSche == 2 || stateSche == 3">
                        {{ $t("nodata") }}
                    </div>

                </div>
            </div>
        </div>


        <footView></footView>
    </div>
</template>

<script>
import Pagination from "@/components/Pagination";

import { getArticleType, getPageList } from "@/request/api";

export default {
    name: "articleIndex",
    components: { Pagination },
    props: {
        pageType: {
            type: Number,
            default: 2  //2新闻、4案例
        }
    },
    data() {
        return {
            stateSche: 0,
            total: 0,
            listLoading: false,
            listQuery: {
                Page: 1,
                Limit: 10
            },
            pageTitle: "",
            hotList: [],
            categories: [],
            currentCategory: 'all',
            list: [],
        }
    },
    mounted() {
        let that = this;
        this.getDataList();
        getArticleType("pageType=" + this.pageType).then(res => {
            this.categories = [
                {
                    id: "all",
                    typeName: "全部",
                },
                ...res.data
            ];
        })

        // 热门
        getPageList({
            pageParm: {
                page: 1,
                limit: 4,
                keyword: "",
                field: "",
                sort: 0
            },
            isEnable: 1,
            isFooter: "0",
            pageType: that.pageType || 2,
            isHot: 1,
        }).then((res) => {
            that.listLoading = false;

            if (res.code == 200) {
                that.hotList = that.setProcess(res.data.data);
            }
        });



    },
    created() { },
    methods: {
        getDataList() {
            let that = this;
            that.stateSche = 1;
            that.listLoading = true;
            let para = {
                pageParm: {
                    page: that.listQuery.Page,
                    limit: that.listQuery.Limit,
                    keyword: "",
                    field: "",
                    sort: 0
                },
                isEnable: 1,
                isFooter: "0",
                title: that.pageTitle || "",
                pageType: that.pageType || 2,
                articleTypeId: this.currentCategory == "all" ? null : this.currentCategory,
            };
            getPageList(para).then((res) => {
                that.listLoading = false;

                if (res.code == 200) {
                    that.list = that.setProcess(res.data.data);
                    that.total = res.data.dataCount;
                    that.stateSche = that.list.length ? 0 : 2;
                } else if (res.code == 204) {
                    that.list = null;
                    that.stateSche = 2;
                } else {
                    that.list = null;
                    that.stateSche = 3;
                }
            });
        },

        setProcess(data) {
            if (data && data.length > 0) {
                data.map(item => {
                    item.date = (item.modifyTime || item.createTime) ? (item.modifyTime || item.createTime).split(" ")[0] : '';
                    item.linkUrl = item.externalLink || ("/article/detail/" + item.id)

                    return item
                })
            }
            return data || [];
        },


        handDetail(id) {
            let linkUrl = "/page/index/" + id
            this.$router.push(linkUrl);
        },

        handCategory(id) {
            this.currentCategory = id;
            this.listQuery.Page = 1;
            this.getDataList();
        },

        //筛选
        handleFilter() {
            this.listQuery.Page = 1;
            this.getDataList();
        },
        //分页回调
        handlePagination(data) {
            var that = this;
            if (data) {
                that.listQuery.Page = data.page;
                that.listQuery.Limit = data.limit;
                that.getDataList();
            }
        },
    }
};
</script>

<style scoped lang="scss">
// @import "../../assets/style/news.scss";

.topseat {
    justify-content: space-between;

    .el-icon-location-outline {
        margin-right: 4px;
    }

    .el-icon-arrow-right {
        margin: 0 10px;
    }
}

.news-module {
    .person-nav {
        padding-bottom: 1%;
    }

    .news-module__inner {
        max-width: 1600px;
        margin: 0 auto;
        padding: 2%;
        box-sizing: border-box;
    }

    .el-icon-date {
        color: #e60012;
    }


    .techShow-module__title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 0 20px;
    }

    .techShow-module__head {
        margin-bottom: 8px;
    }

    .techShow-module__en {
        font-size: 28px;
        font-weight: bold;
        color: #333;
        line-height: 1.4;
        margin: 0;
    }

    .techShow-module__sub {
        font-size: 18px;
        line-height: 1.5;
        margin: 0 0 32px;
        color: #e60012;

        ::v-deep p {
            margin: 0 0 6px;
        }

    }

    .techShow-module__cta {
        color: #e60012;
        font-size: 14px;
    }


    .news-module__list {
        display: flex;
        flex-wrap: wrap;
        min-height: 200px;
    }

    .news-list1 {
        .news-module__card {
            flex: 0 0 calc(100% / 5);
            max-width: calc(100% / 5);
        }

        .news-module__card-img {
            height: 150px;
        }
    }

    .news-list3 {
        .news-module__card {
            flex: 0 0 calc(100% / 4);
            max-width: calc(100% / 4);
        }

        .news-module__card-img {
            height: 180px;
        }
    }


    .news-module__section-title {
        font-size: 22px;
        font-weight: bold;
        color: #333;
        line-height: 1.4;
        margin: 0 0 20px;
        padding-left: 12px;
        border-left: 4px solid #e60012;
    }


    .news-module__hot {
        margin-bottom: 48px;
    }

    .news-module__hot-body {
        display: flex;
        gap: 24px;
        align-items: stretch;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    }

    .news-module__hot-main {
        flex: 0 0 60%;
        max-width: 60%;
        background: #fff;
        border-radius: 12px;
        overflow: hidden;
        text-decoration: none;
        color: inherit;
        display: flex;

        // transition: all 0.3s;
        // &:hover {
        //     transform: translateY(-4px);
        // }
    }

    .news-module__hot-main-img {
        flex: 0 0 56%;
        max-width: 56%;
        height: 300px;
        overflow: hidden;
        background: #f5f5f5;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }

    .news-module__hot-main-body {
        flex: 1;
        min-width: 0;
        padding: 28px 24px;
        display: flex;
        flex-direction: column;
    }

    .news-module__hot-tag {
        display: inline-block;
        align-self: flex-start;
        font-size: 13px;
        color: #e60012;
        background-color: rgba(255, 8, 70, 0.1);
        border-radius: 3px;
        padding: 2px 8px;
        margin-bottom: 14px;
    }

    .news-module__hot-main-title {
        font-size: 22px;
        font-weight: bold;
        color: #333;
        line-height: 1.4;
        margin: 0 0 12px;
        font-family: "pingfang heavy";
    }

    .news-module__hot-main-date {
        font-size: 13px;
        color: #666;
        margin: 0 0 14px;
        display: flex;
        align-items: center;

        i {
            margin-right: 4px;
        }
    }

    .news-module__hot-main-desc {
        font-size: 13px;
        color: #666;
        line-height: 1.7;
        margin: 0 0 18px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        flex: 1;
        min-height: 0;
    }

    .news-module__hot-main-more {
        font-size: 14px;
        color: #e60012;
        margin: 0;
    }

    .news-module__hot-side {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
    }

    .news-module__hot-side-item {
        flex: 1;
        display: flex;
        align-items: center;
        background: #fff;
        border-radius: 10px;
        padding: 14px;
        text-decoration: none;
        color: inherit;
        transition: all 0.3s;

        &:hover {
            transform: translateY(-3px);
            box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
        }
    }

    .news-module__hot-side-item:first-child {
        display: none;
    }

    .news-module__hot-side-img {
        width: 96px;
        height: 72px;
        flex: none;
        border-radius: 6px;
        overflow: hidden;
        background: #f5f5f5;
        margin-right: 16px;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }

    .news-module__hot-side-text {
        flex: 1;
        min-width: 0;
    }

    .news-module__hot-side-title {
        font-size: 15px;
        font-weight: 500;
        color: #333;
        line-height: 1.5;
        margin: 0 0 8px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .news-module__hot-side-date {
        font-size: 12px;
        color: #666;
        margin: 0;
        display: flex;
        align-items: center;

        i {
            margin-right: 4px;
        }
    }


    .news-module__news {
        margin-bottom: 48px;
    }

    .news-module__news-head {
        display: flex;
        align-items: center;
        gap: 24px;
        margin-bottom: 24px;
        flex-wrap: wrap;

        .news-module__section-title {
            margin: 0;
            flex: none;
        }
    }

    .news-module__news-cats {
        display: flex;
        gap: 18px;
        flex: 1;
        min-width: 0;
        flex-wrap: wrap;
        justify-content: center;
    }

    .news-module__news-cat {
        display: inline-block;
        padding: 6px 20px;
        font-size: 14px;
        color: #555;
        background: #fff;
        border: 1px solid #e0e0e0;
        border-radius: 20px;
        cursor: pointer;
        transition: all 0.2s;

        &:hover {
            color: #e60012;
            border-color: #e60012;
        }

        &.active {
            color: #fff;
            background: #e60012;
            border-color: #e60012;
        }
    }

    .news-module__news-head .input-with-select {
        width: 240px;
        flex: none;
    }


    .news-module__card {
        box-sizing: border-box;
        background: #fff;
        border-radius: 12px;
        padding: 0 12px 12px;
        transition: all 0.3s;
        margin-bottom: 24px;
        text-decoration: none;
        color: inherit;

        &:hover {
            transform: translateY(-6px);
        }
    }

    .news-module__card-item {
        width: 100%;
        height: 100%;
        border-radius: 10px;
        overflow: hidden;
        background: #fff;
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);

    }

    .news-module__card-img {
        display: block;
        width: 100%;
        overflow: hidden;
        background: #f5f5f5;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }

    .news-module__card-body {
        padding: 14px 14px 12px;
    }

    .news-module__card-tag {
        display: inline-block;
        font-size: 12px;
        color: #e60012;
        background-color: rgba(255, 8, 70, 0.1);
        border-radius: 3px;
        padding: 2px 8px;
        margin-bottom: 8px;
    }

    .news-module__card-title {
        font-size: 15px;
        font-weight: bold;
        color: #333;
        line-height: 1.4;
        margin: 0 0 8px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .news-module__card-desc {
        font-size: 12px;
        color: #666;
        line-height: 1.6;
        margin: 0 0 12px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        min-height: 40px;
    }

    .news-module__card-foot {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .news-module__card-date {
        font-size: 14px;
        color: #666;
    }

    .arrow {
        width: 24px;
        height: 24px;
        margin-left: 16px;
        flex: none;
    }

    .news-module__edit-card {
        border: 1px solid #ebeef5;
        border-radius: 4px;
        padding: 12px;
        margin-bottom: 12px;
        background: #fafafa;
    }

    .news-module__edit-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: bold;
        margin-bottom: 8px;
    }
}




@media screen and (max-width: 1200px) {
    .news-module {
        .news-list1 {
            .news-module__card {
                flex: 0 0 calc(100% / 3);
                max-width: calc(100% / 3);
            }
        }
    }
}

@media screen and (max-width: 768px) {



    .news-module {
        .news-module__news-head {
            flex-direction: column;
            align-items: start;

            .input-with-select {
                width: 97% !important;
            }
        }

        .news-module__news-cats {
            justify-content: start;
        }


        .news-list1 {
            flex-direction: column;

            .news-module__card {
                flex: 1;
                max-width: 100%;
                margin-bottom: 16px;

            }

            .news-module__card-item {
                margin: 0;
                display: flex;
            }

            .news-module__card-img {
                width: 140px;
                height: 140px;
                margin: 0;
                flex: none;
            }

            .news-module__card-title {
                font-size: 18px;
            }

            .news-module__card-desc {
                font-size: 16px;
            }

            .news-module__card-date {
                font-size: 17px;
            }


        }

        .news-module__card-body {
            flex: 1;
        }


        .news-module__hot-side-item {
                align-items: start;
                  .news-module__hot-body {
                flex-direction: column;
            }
            
            .news-module__hot-side-img{
                width: 130px;
                height: 130px;
                margin-right: 12px;
                flex: none;
            }

            .news-module__hot-side-title{
                font-size: 18px;
                font-weight: 700;
            }

           .el-icon-date{
            font-size: 20px;
           }
            .news-module__hot-side-date {
                font-size: 17px;
            }


          
        }



        .news-module__hot-main {
            display: none;
        }

        .news-module__hot-side-item:first-child {
            display: flex;
        }



    }
}
</style>